<template>
  <div>
    <h4>
      {{ "entity_list" | translate({ entity: entity || defaultEntity }) }}
      <button
        class="btn btn-primary btn-sm"
        @click="addNewTransaction"
      >{{ "add_new_entity" | translate({ entity: entity || defaultEntity }) }}</button>
    </h4>
    <table class="table table-sm table-bordered">
      <thead>
        <tr>
          <th>{{ "account" | translate }}</th>
          <th class="w-35">{{ "amount" | translate }}</th>
          <th class="w-25">{{ "currency" | translate }}</th>
          <th>@</th>
        </tr>
      </thead>

      <tr v-for="(trans, index) in transactions" :key="index">
        <td>
          <input
            type="text"
            class="table-input"
            v-model="trans.account"
            :placeholder="
              'entity_account' | translate({ entity: entity || defaultEntity })
            "
          />
        </td>
        <td>
          <div style="position: relative">
            <input
              type="number"
              class="table-input"
              v-model.number="trans.amount"
              :placeholder="
              'entity_amount' | translate({ entity: entity || defaultEntity })
            "
            />

            <a
              href="javascript:void(0)"
              @click="fillRemaining(trans)"
              style="position: absolute; right: 0;"
            >
              <i class="fa fa-fw fa-calculator"></i>
            </a>
          </div>
        </td>
        <td>
          <currency-picker class="table-input" v-model="trans.currency" v-if="!currency"></currency-picker>
          <div v-if="currency">{{ currency | translate }}</div>
        </td>
        <td class="w-min no-br">
          <a
            href="javascript:void(0)"
            @click="removeTransaction(index)"
            v-if="index !== 0"
          >{{ "remove" | translate }}</a>
          <span v-else style="text-decoration: line-through">
            {{
            "remove" | translate
            }}
          </span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  props: ["transactions", "entity", "currency", "total"],
  data() {
    return {
      defaultEntity: this.$translate.translate("transaction"),
    };
  },
  watch: {
    currency() {
      _.forEach(this.transactions, (trans) => (trans.currency = this.currency));
    },
  },
  methods: {
    addNewTransaction() {
      this.transactions.push({
        account: null,
        amount: null,
        currency: this.currency,
      });
    },
    fillRemaining(transaction) {
      let total = this.total;
      let otherSum = _.reduce(
        this.transactions,
        (result, trans) => {
          if (trans === transaction) return result;
          return trans.amount ? result + trans.amount : result;
        },
        0
      );
      let remaining = total - otherSum;
      transaction.amount = remaining > 0 ? +remaining.toFixed(2) : 0;
    },
    removeTransaction(index) {
      this.transactions.splice(index, 1);
    },
  },
};
</script>
